import { TFunction } from '@lyearn/i18n';
import { FilterOperatorEnum } from '@/types/schema';

import { OperatorSelectVariant } from './type';

export const getOperatorSelectValues = (t: TFunction, variant: OperatorSelectVariant) => {
  const isAndOrVariant = variant === OperatorSelectVariant.AndOr;

  return [
    {
      id: FilterOperatorEnum.And,
      label: isAndOrVariant ? t('Group:Editor.And') : t('Common:All'),
    },
    {
      id: FilterOperatorEnum.Or,
      label: isAndOrVariant ? t('Group:Editor.Or') : t('Group:Editor.Any'),
    },
  ];
};
